export default {
  bindings: {
    error: '@',
    statusCode: '@'
  },
  template: require('../views/http.error.html')
};
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/error/components/http.error.component.js